import { render, staticRenderFns } from "./messageEditor.vue?vue&type=template&id=08a799a6&scoped=true&"
import script from "./messageEditor.vue?vue&type=script&lang=js&"
export * from "./messageEditor.vue?vue&type=script&lang=js&"
import style0 from "./messageEditor.vue?vue&type=style&index=0&id=08a799a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a799a6",
  null
  
)

export default component.exports